// CouriersRoutesXL - Sprint 44 Fase 3 Vista 6.
// Reemplaza modules/couriers/routes.jsx. Ruta unica preservada: /couriers.
import { Routes, Route } from 'react-router-dom';
import CouriersPageXL from './CouriersPageXL';

export default function CouriersRoutesXL() {
  return (
    <Routes>
      <Route index element={<CouriersPageXL />} />
    </Routes>
  );
}
